import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useSiteTemplate } from './useSiteTemplate'
import { isAustraliaEnglishCopy, translateAustraliaTemplateText, translateStorefrontUi } from '~/utils/australiaUiCopy'

export function useStorefrontUiCopy(fallbackTranslate) {
  const i18n = useI18n({ useScope: 'global' })
  const { templateKey } = useSiteTemplate()
  const isAustraliaEnglish = computed(() => isAustraliaEnglishCopy(templateKey.value, i18n.locale.value))
  const t = (key, params = {}, ...args) => translateStorefrontUi(key, params, {
    templateKey: templateKey.value,
    locale: i18n.locale.value,
  }, () => fallbackTranslate ? fallbackTranslate(key, params, ...args) : i18n.t(key, params, ...args))
  const text = value => translateAustraliaTemplateText(value, templateKey.value, i18n.locale.value)
  // A confirmed action has a known UI outcome. Do not expose a generic server
  // success message in place of the approved English confirmation.
  const successMessage = (key, serverMessage) => isAustraliaEnglish.value ? t(key) : (serverMessage || t(key))
  return { t, text, locale: i18n.locale, isAustraliaEnglish, successMessage }
}
